import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import clsx from 'clsx';

type H1Props = ComponentPropsWithoutRef<'h1'> & {
    className?: string;
    children: ReactNode;
};

function H1({ className = '', children, ...restProps }: H1Props) {
    return (
        <h1 className={clsx('font-GBold text-5xl', className)} {...restProps}>
            {children}
        </h1>
    );
}

export default H1;
